import styled from 'styled-components'

type RootProps = {
  isDesktop: boolean
}

export const Root = styled.div<RootProps>`
  display: flex;
  height: 100%;
  flex-direction: column;

  ${({ isDesktop }) =>
    isDesktop &&
    `
    flex-direction: row;
  `}
`

export const BannerSection = styled.div`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 25;
`

export const ContentWrapper = styled.div`
  position: relative;
  flex: 1 0;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  position: relative;
  flex: 1 0;
  overflow: auto;
`

export const Sidebar = styled.div`
  flex-shrink: 0;
  overflow-y: auto;
`

export const SidebarInsides = styled.div`
  display: flex;
  max-width: 360px;
  min-width: 84px;
  min-height: 100%;

  ${({ theme }) => `
    background-color: ${theme.color.oceanSidebar};
    ${theme.pattern};
  `}
`

type MobilebarProps = {
  isDesktop: boolean
}

export const Mobilebar = styled.div<MobilebarProps>`
  flex-shrink: 0;
  height: 60px;
  display: block;

  ${({ theme }) => `
    background-color: ${theme.color.oceanSidebar};
    ${theme.pattern};
  `}

  ${({ isDesktop }) =>
    isDesktop &&
    `
      display: none;
  `}
`
